@if (filterConfiguration) {
	<section class="form border-bottom-gray">
		<div class="row row-cols-lg-3">
			<ng-template #brandModel>
				<div class="field mb-3">
					<label for="licenseBrandSelect">{{ "auction.details.brand" | translate }}</label>
					@if (filterConfiguration.brand.values.length) {
						<select
							class="defaultInput mt-2"
							id="licenseBrandSelect"
							(change)="filterChanged('brand', $event)"
							[ngModel]="filterConfiguration.brand.value"
						>
							<option value=""></option>
							@for (opt of filterConfiguration.brand.values; track opt) {
								<option [value]="opt">{{ opt }}</option>
							}
						</select>
					}
				</div>
				<div class="field mb-3">
					<label for="modelInput">{{ "auction.details.model" | translate }}</label>
					<input
						class="defaultInput mt-2"
						id="modelInput"
						type="text"
						(input)="filterChanged('model', $event)"
						[value]="filterConfiguration.model.value"
					/>
				</div>
			</ng-template>
			<ng-template #plateFrame>
				<div class="field mb-3">
					<label for="licensePlateInput">{{ "auction.details.licensePlate" | translate }}</label>
					<input
						class="defaultInput mt-2"
						id="licensePlateInput"
						type="text"
						(input)="filterChanged('licensePlate', $event)"
						[value]="filterConfiguration.licensePlate.value"
					/>
				</div>
				<div class="field mb-3">
					<label for="vehicleframeInput">{{ "auction.details.frame" | translate }}</label>
					<input
						class="defaultInput mt-2"
						id="vehicleframeInput"
						type="text"
						(input)="filterChanged('frame', $event)"
						[value]="filterConfiguration.frame.value"
					/>
				</div>
			</ng-template>
			@switch (configuration) {
				@case ("auctionDetails") {
					<div class="field mb-3">
						<label for="statusSelect">{{ "auction.details.status" | translate }}</label>
						@if (filterConfiguration.status.values.length) {
							<select
								class="defaultInput mt-2"
								id="statusSelect"
								(change)="filterChanged('status', $event)"
								[ngModel]="filterConfiguration.status.value"
							>
								<option
									value=""
									selected
								></option>
								@for (opt of $any(filterConfiguration.status.values); track opt.elementCode) {
									<option [value]="opt.elementCode">
										{{ opt.elementCode | clkBizCT: "LOT_SEARCH_STATUS" }}
									</option>
								}
							</select>
						}
					</div>
					<ng-container *ngTemplateOutlet="brandModel" />
					<div class="field mb-3">
						<label for="areaSelect">{{ "auction.details.locateArea" | translate }}</label>
						@if (filterConfiguration.area.values.length) {
							<select
								class="defaultInput mt-2"
								id="areaSelect"
								(change)="filterChanged('area', $event)"
								[ngModel]="filterConfiguration.area.value"
							>
								<option value=""></option>
								@for (opt of $any(filterConfiguration.area.values); track opt.elementCode) {
									<option [value]="opt.elementCode">
										{{ opt.elementCode | clkBizCT: "COUNTRY_AREA" : vehicleMarket }}
									</option>
								}
							</select>
						}
					</div>
					@if (!filterConfiguration.year.hideThis) {
						<div class="field3 mb-3">
							<label>{{ "auction.details.year" | translate }}</label>
							@if (filterConfiguration.year.sliderConfig.step) {
								<ngx-slider
									(userChangeEnd)="rangeFilterChanged('year', [$event.value, $event.highValue])"
									[value]="filterConfiguration.year.rangeValue[0]"
									[highValue]="filterConfiguration.year.rangeValue[1]"
									[options]="filterConfiguration.year.sliderConfig"
								/>
							}
						</div>
					}
					@if (!filterConfiguration.km.hideThis) {
						<div class="field3 mb-3">
							<label>{{ (vehicleMarket === "EN" ? "auction.live.miles" : "auction.details.kilometers") | translate }}</label>
							@if (filterConfiguration.km.sliderConfig.step) {
								<ngx-slider
									(userChangeEnd)="rangeFilterChanged('km', [$event.value, $event.highValue])"
									[value]="filterConfiguration.km.rangeValue[0]"
									[highValue]="filterConfiguration.km.rangeValue[1]"
									[options]="filterConfiguration.km.sliderConfig"
								/>
							}
						</div>
					}
					<!--
						NOTE: not considering the "hideability" of the field cause price will change,
								and the field (which will almost never be hidden, since there is always a price, but unlikely identical)
								may pop-in/out.
								Other filter attributes will never change, hence the field will always be hidden or shown.
						@if (!filterConfiguration.budget.hideThis) {
					 -->
					<div class="field3 mb-3">
						<label>{{ "auction.details.budget" | translate }}</label>
						@if (filterConfiguration.budget.sliderConfig.step) {
							<ngx-slider
								(userChangeEnd)="rangeFilterChanged('budget', [$event.value, $event.highValue])"
								[value]="filterConfiguration.budget.rangeValue[0]"
								[highValue]="filterConfiguration.budget.rangeValue[1]"
								[options]="filterConfiguration.budget.sliderConfig"
							/>
						}
					</div>
					<!-- } -->
					@if (!filterConfiguration.damage.hideThis) {
						<div class="field3 mb-3">
							<label>{{ "auction.details.damage" | translate }}</label>
							@if (filterConfiguration.damage.sliderConfig.step) {
								<ngx-slider
									(userChangeEnd)="rangeFilterChanged('damage', [$event.value, $event.highValue])"
									[value]="filterConfiguration.damage.rangeValue[0]"
									[highValue]="filterConfiguration.damage.rangeValue[1]"
									[options]="filterConfiguration.damage.sliderConfig"
								/>
							}
						</div>
					}
					<ng-container *ngTemplateOutlet="plateFrame" />
				}
				@case ("purchase") {
					<div class="field mb-3">
						@if (filterConfiguration.templateName.values.length) {
							<label for="templateNameSelect"> {{ "shoppingCart.template" | translate }} </label>
							<select
								class="defaultInput mt-2"
								id="templateNameSelect"
								(change)="filterChanged('templateName', $event)"
								[ngModel]="filterConfiguration.templateName.value"
							>
								<option
									value=""
									selected
								></option>
								@for (name of filterConfiguration.templateName.values; track name) {
									<option [value]="name">
										{{ name }}
									</option>
								}
							</select>
						}
					</div>
					<ng-container *ngTemplateOutlet="brandModel" />
					<ng-container *ngTemplateOutlet="plateFrame" />
					<div class="field mb-3">
						<label for="channelSelect"> {{ "shoppingCart.channel" | translate }}: </label>
						@if (filterConfiguration.channel.values.length) {
							<select
								class="defaultInput mt-2"
								id="channelSelect"
								(change)="filterChanged('channel', $event)"
								[ngModel]="filterConfiguration.channel.value"
							>
								<option value=""></option>
								@for (opt of $any(filterConfiguration.channel.values); track opt.elementCode) {
									<option [value]="opt.elementCode">
										{{
											{
												AUCTION: "auction.auctions.auction",
												SHOWCASE: "menu.showcase"
											}[opt.elementCode] | translate
										}}
									</option>
								}
							</select>
						}
					</div>
					@if (!filterConfiguration.date.hideThis) {
						<div class="field mb-3">
							<label for="fromDate"> {{ "shoppingCart.from" | translate }}</label>
							<input
								class="defaultInput mt-2"
								id="fromDate"
								type="text"
								placeholder="DD/MM/YYYY"
								bsDatepicker
								(bsValueChange)="dateFilterChanged('date', $event, 'from')"
								[bsValue]="filterConfiguration.date.dateValues[0]"
								[minDate]="filterConfiguration.date.dateRange[0]"
								[maxDate]="filterConfiguration.date.dateValues[1] || filterConfiguration.date.dateRange[1]"
								[bsConfig]="bsConfig"
							/>
						</div>
						<div class="field mb-3">
							<label for="toDate"> {{ "shoppingCart.to" | translate }}</label>
							<input
								class="defaultInput mt-2"
								id="toDate"
								type="text"
								placeholder="DD/MM/YYYY"
								bsDatepicker
								(bsValueChange)="dateFilterChanged('date', $event, 'to')"
								[bsValue]="filterConfiguration.date.dateValues[1]"
								[minDate]="filterConfiguration.date.dateValues[0] || filterConfiguration.date.dateRange[0]"
								[maxDate]="filterConfiguration.date.dateRange[1]"
								[bsConfig]="bsConfig"
							/>
						</div>
					}
				}
			}
		</div>
	</section>
}